module.exports = __webpack_public_path__ + "static/media/paidPetitioner.30f9a264.pdf";